<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("add") }} {{ $t("cinemasettings") }}
      </div>
      <router-link class="btn-blue" to="/cinema-manager/cinemas"
        >{{ $tc("cinema", 1) }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="edit-movie-container">
      <div class="row">
        <!-- CINEMAS SELECTION -->
        <div class="col-md-4 mb-4">
          <div class="dropdown-curve-container">
            <label
              :class="
                selectedCinema && selectedCinema.length > 0 ? 'shift-up' : ''
              "
              >{{ $tc("cinema", 1) }}</label
            >
            <b-dropdown
              :disabled="isCinemaID"
              :text="selectedCinema"
              name="selectcinema"
              id="selectcinema"
              variant="dropdown-curve"
              class="w-100"
            >
              <b-dropdown-item
                href="#"
                v-for="(Cinema, CinemaIndex) in Cinemas"
                :key="CinemaIndex"
                v-on:click="onSelectCinema($event, Cinema)"
                >{{ Cinema.cine_name }}</b-dropdown-item
              >
            </b-dropdown>
          </div>
          <p
            v-if="submitted && selectedCinema.length == 0"
            class="error_message"
          >
            Please Select Cinema.
          </p>
        </div>
        <div class="col-md-4 mb-4">
          <div class="row">
            <div class="col-6">
              <div class="dropdown-curve-container">
                <label :class="cinema_config.start_time ? 'shift-up' : ''">{{
                  $t("businessStartTime")
                }}</label>
                <vue-timepicker
                  manual-input
                  v-model="cinema_config.start_time"
                  name="operationstime"
                  id="operationstime"
                  format="HH:mm"
                  :placeholder="$t('businessStartTime')"
                  class="time_picker"
                  input-width="100%"
                  auto-scroll
                  lazy
                  @change="onChangeTime($event, 'start')"
                  v-validate="'required'"
                ></vue-timepicker>
              </div>
              <!-- <date-picker
                v-model="cinema_config.cine_operation_start_time"
                lang="en"
                type="time"
                format="hh:mm a"
                :minute-step="1"
                class="time_picker"
                placeholder="Operation Start Time"
                @input="onclose($event)"
                name="operationstime"
                id="operationstime"
                v-validate="'required'"
              ></date-picker> -->

              <p
                v-if="submitted && errors.has('operationstime')"
                class="error_msg"
              >
                {{ errors.first("operationstime") }}
              </p>
            </div>
            <div class="col-6">
              <div class="dropdown-curve-container">
                <label :class="cinema_config.end_time ? 'shift-up' : ''">{{
                  $t("businessEndTime")
                }}</label>
                <vue-timepicker
                  manual-input
                  v-model="cinema_config.end_time"
                  name="operationetime"
                  id="operationetime"
                  format="HH:mm"
                  :placeholder="$t('businessEndTime')"
                  class="time_picker"
                  input-width="100%"
                  auto-scroll
                  lazy
                  @change="onChangeTime($event, 'end')"
                  v-validate="'required'"
                ></vue-timepicker>
              </div>
              <!-- <date-picker
                v-model="cinema_config.cine_operation_end_time"
                lang="en"
                type="time"
                format="hh:mm a"
                :minute-step="1"
                class="time_picker"
                placeholder="Operation End Time"
                @input="onclose($event)"
                name="operationetime"
                id="operationetime"
                v-validate="'required'"
              ></date-picker> -->
              <p
                v-if="submitted && errors.has('operationetime')"
                class="error_msg"
              >
                {{ errors.first("operationetime") }}
              </p>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="cinema_config.cine_cleaning_time_in_mins"
                type="text"
                name="cleaningtime"
                id="cleaningtime"
                v-validate="'required|numeric'"
              />
              <label>{{ $t("cleaningtime") }} ( {{ $t("inmins") }} )</label>
            </div>
            <!-- <Tooltip :title="$t('cinemaSettingsCleaningTime_tooltip')" /> -->
          </div>
          <p
            v-if="submitted && errors.has('cleaningtime')"
            class="error_message"
          >
            <!-- {{ item.fieldname }} -->
            {{ errors.first("cleaningtime") }}
          </p>
        </div>

        <div class="col-md-4 mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="cinema_config.cine_setting_ads_time_in_mins"
                type="text"
                name="settingadstime"
                id="settingadstime"
                v-validate="'required|numeric'"
              />
              <label
                >{{ $t("advertisementtime") }} ( {{ $t("inmins") }} )</label
              >
            </div>
            <!-- <Tooltip :title="$t('cinemaSettingsAdvertisementTime_tooltip')" /> -->
          </div>
          <p
            v-if="submitted && errors.has('settingadstime')"
            class="error_message"
          >
            <!-- {{ item.fieldname }} -->
            {{ errors.first("settingadstime") }}
          </p>
        </div>

        <!-- intervaltime -->
        <div class="col-md-4 mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="cinema_config.cine_interval_time_in_mins"
                type="text"
                name="intervaltime"
                id="intervaltime"
                v-validate="'required|numeric'"
              />
              <label>{{ $t("intervaltime") }} ( {{ $t("inmins") }} )</label>
            </div>
            <!-- <Tooltip :title="$t('cinemaSettingsAdvertisementTime_tooltip')" /> -->
          </div>
          <p
            v-if="submitted && errors.has('intervaltime')"
            class="error_message"
          >
            <!-- {{ item.fieldname }} -->
            {{ errors.first("intervaltime") }}
          </p>
        </div>

        <div class="col-md-4 mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="cinema_config.cine_seat_release_time_in_mins"
                type="text"
                name="releasetime"
                id="releasetime"
                v-validate="'required|numeric'"
              />
              <label>{{ $t("seatreleasetime") }} ( {{ $t("inmins") }} )</label>
            </div>
            <!-- <Tooltip :title="$t('cinemaSettingsSeatReleaseTime_tooltip')" /> -->
          </div>
          <p
            v-if="submitted && errors.has('releasetime')"
            class="error_message"
          >
            <!-- {{ item.fieldname }} -->
            {{ errors.first("releasetime") }}
          </p>
        </div>

        <div class="col-md-4 mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="cinema_config.cine_cutoff_time_in_mins"
                type="text"
                name="cutofftime"
                id="cutofftime"
                v-validate="{ required: 'required', regex: /-?\d+/ }"
              />
              <label>{{ $t("POS_cutoff_time") }} ( {{ $t("inmins") }} )</label>
            </div>
            <!-- <Tooltip :title="$t('cinemaSettingsCutofTime_tooltip')" /> -->
          </div>
          <p v-if="submitted && errors.has('cutofftime')" class="error_message">
            <!-- {{ item.fieldname }} -->
            {{ errors.first("cutofftime") }}
          </p>
        </div>

        <div class="col-md-4 mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="cinema_config.kiosk_cutoff_time_in_mins"
                type="text"
                name="kioskcutofftime"
                id="kioskcutofftime"
                v-validate="{ required: 'required', regex: /-?\d+/ }"
              />
              <label
                >{{ $t("kiosk_cutoff_time") }} ( {{ $t("inmins") }} )</label
              >
            </div>
            <!-- <Tooltip :title="$t('cinemaSettingsCutofTime_tooltip')" /> -->
          </div>
          <p
            v-if="submitted && errors.has('kioskcutofftime')"
            class="error_message"
          >
            <!-- {{ item.fieldname }} -->
            {{ errors.first("kioskcutofftime") }}
          </p>
        </div>

        <div class="col-md-4 mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="cinema_config.website_cutoff_time_in_mins"
                type="text"
                name="websitecutofftime"
                id="websitecutofftime"
                v-validate="{ required: 'required', regex: /-?\d+/ }"
              />
              <label
                >{{ $t("website_cutoff_time") }} ( {{ $t("inmins") }} )</label
              >
            </div>
            <!-- <Tooltip :title="$t('cinemaSettingsCutofTime_tooltip')" /> -->
          </div>
          <p
            v-if="submitted && errors.has('websitecutofftime')"
            class="error_message"
          >
            <!-- {{ item.fieldname }} -->
            {{ errors.first("websitecutofftime") }}
          </p>
        </div>

        <div class="col-md-4 mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="cinema_config.entry_before_show_start"
                type="number"
                name="entry_before_show_start"
                id="entry_before_show_start"
                v-validate="'required|numeric'"
              />
              <label
                >{{ $t("entry_before_show_start") }} (
                {{ $t("inmins") }} )</label
              >
            </div>
            <!-- <Tooltip :title="$t('entry_before_show_start_tooltip')" /> -->
          </div>
          <p
            v-if="submitted && errors.has('entry_before_show_start')"
            class="error_message"
          >
            <!-- {{ item.fieldname }} -->
            {{ $t("entry_before_show_start_required") }}
          </p>
        </div>

        <div class="col-md-4 mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="cinema_config.entry_after_show_start"
                type="number"
                name="entry_after_show_start"
                id="entry_after_show_start"
                v-validate="'required|numeric'"
              />
              <label
                >{{ $t("entry_after_show_start") }} (
                {{ $t("inmins") }} )</label
              >
            </div>
            <!-- <Tooltip :title="$t('entry_after_show_start_tooltip')" /> -->
          </div>
          <p
            v-if="submitted && errors.has('entry_after_show_start')"
            class="error_message"
          >
            <!-- {{ item.fieldname }} -->
            {{ $t("entry_after_show_start_required") }}
          </p>
        </div>

        <div class="col-md-4 mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="cinema_config.cine_ipaddress_range"
                type="text"
                name="ipaddress"
                id="ipaddress"
                v-validate="{
                  required: 'required',
                  regex: /[\d*]+\.[\d*]+\.[\d*]+\.[\d*]+/,
                }"
              />
              <!-- /^[0-9]{1,3}([.][0-9]{1,3})([.][0-9]{1,3})([.][0-9]{1,3})?$/ -->
              <label>{{ $t("ipaddressrange") }}</label>
            </div>
            <!-- <Tooltip :title="$t('IpAddressRange_tooltip')" /> -->
          </div>
          <p v-if="submitted && errors.has('ipaddress')" class="error_message">
            {{ errors.first("ipaddress") }}
          </p>
        </div>

        <div class="col-md-4 mb-4">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <label :class="cinema_config.cine_time_zone ? 'shift-up' : ''">{{
                $t("timeZoneTitle")
              }}</label>
              <multiselect
                v-model="cinema_config.cine_time_zone"
                :options="timeZones"
                track-by="tz_id"
                label="tz_name"
                :multiple="false"
                :placeholder="$t('timeZoneTitle')"
              ></multiselect>
            </div>
            <!-- <Tooltip :title="$t('timezone')" /> -->
          </div>
          <p class="error_message">
            <span
              v-if="
                submitted &&
                (!cinema_config.cine_time_zone ||
                  cinema_config.cine_time_zone.length == 0)
              "
              >Please Select Time Zone.</span
            >
          </p>
        </div>

        <div class="col-md-4 mb-4">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <label :class="selected_day ? 'shift-up' : ''">{{
                $t("start_day")
              }}</label>
              <multiselect
                v-model="selected_day"
                :options="Days"
                track-by="id"
                label="day"
                :multiple="false"
                @select="onSelectDay($event)"
                :placeholder="$t('start_day')"
              ></multiselect>
            </div>
            <!-- <Tooltip :title="$t('start_day')" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && !cinema_config.start_day"
              >Please Select Day.</span
            >
          </p>
        </div>

        <div class="col-md-4 mb-4" v-if="screens.length > 0">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="cinema_config.mycinema_creation_interval"
                type="text"
                name="mycinema_creation_interval_time"
                id="mycinema_creation_interval_time"
                v-validate="'numeric'"
              />
              <label
                >{{
                  $store.getters.isGogoCinema == "Y"
                    ? $t("ondemand_creation_interval_time")
                    : $t("mycinema_creation_interval_time")
                }}
                ( {{ $t("inmins") }} )</label
              >
            </div>
            <!-- <Tooltip
              :title="
                $store.getters.isGogoCinema == 'Y'
                  ? $t('cinemaSettings_ondemand_creation_interval_tooltip')
                  : $t('cinemaSettings_mycinema_creation_interval_tooltip')
              "
            /> -->
          </div>
          <p
            v-if="submitted && errors.has('mycinema_creation_interval_time')"
            class="error_message"
          >
            <!-- {{ item.fieldname }} -->
            {{ errors.first("mycinema_creation_interval_time") }}
          </p>
        </div>

        <div class="col-md-4 mb-4">
          <div class="row">
            <div class="col-10">
              <div class="d-flex align-items-center">
                <label
                  class="material-file-upload"
                  @click.prevent.stop="setModalData()"
                >
                  <div
                    class="label"
                    style="font-size: 11px"
                    v-bind:class="{
                      'shift-up': cinema_config.temp_artwork_image_path,
                    }"
                  >
                    {{ "Temporary Movie Artwork Image" }}
                    {{ "- " + set_width + " X " + set_height }}
                  </div>
                  <div class="uploaded-file-name">
                    <div class="text-truncate pt-2">
                      {{ cinema_config.temp_artwork_image_path }}
                    </div>
                  </div>
                </label>

                <!-- <Tooltip
                  :title="
                    `Temporary Movie Artwork Image - ${set_width} X ${set_height}`
                  "
                /> -->
              </div>
            </div>
            <div class="col-2 align-self-center pl-3">
              <img
                width="40"
                height="40"
                class="rounded c-pointer img-preview"
                @click="openImageModal()"
                :src="_GetImagePath(cinema_config.temp_artwork_image_path)"
                v-if="cinema_config.temp_artwork_image_path"
              />
              <img
                v-else
                width="35"
                height="35"
                class="rounded"
                alt="Empty Image"
                src="@/assets/img/icons/empty-image.svg"
              />
            </div>
          </div>
        </div>

        <div class="col-md-12 mb-4 align-items-center row">
          <div class="col-12 ml-2" v-if="screens.length > 0">
            <p>
              {{
                $store.getters.isGogoCinema == "Y"
                  ? $t("select_ondemand_screens")
                  : $t("select_mycinema_screens")
              }}
            </p>
          </div>
          <div class="col-12 ml-2" v-if="screens.length > 0">
            <b-button
              v-for="(screen, screenIndex) in screens"
              :key="screenIndex"
              :class="`mx-1 cursor-pointer custom-button mb-2 custom-button-no-hover`"
              @click="onClickScreen($event, screen, screenIndex)"
              :variant="
                selectedScreens.findIndex(
                  (x) => x.screen_id == screen.screen_id
                ) !== -1
                  ? 'primary'
                  : 'outline-primary'
              "
              >{{ screen.screen_name }}</b-button
            >
          </div>
        </div>

        <div class="col-12 row">
          <div class="col-12">
            <label> Show Type </label>
          </div>
          <div
            class="col-3 mb-3 ml-3 d-flex justify-content-start align-items-center"
            v-for="(item, index_s) in ShowTypeArray"
            :key="index_s + item.screening_name"
          >
            <input
              type="checkbox"
              class="ios-checkbox"
              v-model="item.status"
              style="height: 20px; width: 20px; margin-right: 5px"
            />
            <span class="switch-slider"> {{ item.screening_name }}</span>
          </div>
        </div>

        <!-- REDEEMABLE ON NET-VALUE / GROSS AMOUNT  -->
        <div class="col-md-6 mb-4">
          <div class="d-flex align-items-center">
            <b-form-radio
              value="NetAmount"
              class="j-radio"
              v-model="cinema_config.discount_is_available_on"
            >
              <div>
                <span>Discount is available on net amount</span>
              </div>
            </b-form-radio>
            <strong class="mx-3">OR</strong>

            <b-form-radio
              value="GrossAmount"
              class="j-radio"
              v-model="cinema_config.discount_is_available_on"
            >
              <div>
                <span>Discount is available on gross amount</span>
              </div>
            </b-form-radio>
          </div>
        </div>

        <div class="col-md-6 mb-4">
          <div class="row">
            <div class="col-md-4 col-xl-2">
              <label>{{ $t("onlinevisibility") }}</label>
            </div>
            <div class="col-md-8 col-xl-10">
              <b-form-checkbox
                v-model="cinema_config.cine_online_visibility"
                value="Y"
                unchecked-value="N"
                name="check-button"
                switch
                class="j-checkbox mb-0 ml-2"
              ></b-form-checkbox>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb-4">
          <div class="row">
            <div class="col-md-3 col-xl-6">
              <label>{{ $t("sellinboxoffice") }}</label>
            </div>
            <div class="col-md-9 col-xl-6">
              <b-form-checkbox
                v-model="cinema_config.cine_sell_fnb_in_boxoffice"
                value="Y"
                unchecked-value="N"
                name="check-button"
                switch
                class="j-checkbox mb-0 ml-2"
              ></b-form-checkbox>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb-4">
          <div class="row">
            <div class="col-md-3 col-xl-6">
              <label>{{ $t("include") }} {{ $t("floatAmount") }}</label>
            </div>
            <div class="col-md-9 col-xl-6">
              <b-form-checkbox
                v-model="cinema_config.cine_include_float_amount"
                value="Y"
                unchecked-value="N"
                name="check-button"
                switch
                class="j-checkbox mb-0 ml-2"
              ></b-form-checkbox>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb-4">
          <div class="row">
            <div class="col-md-3 col-xl-6">
              <label>{{ $t("include") }} {{ $t("shiftclose") }}</label>
            </div>
            <div class="col-md-9 col-xl-6">
              <b-form-checkbox
                v-model="cinema_config.cine_include_shift_close"
                value="Y"
                unchecked-value="N"
                name="check-button"
                switch
                class="j-checkbox mb-0 ml-2"
              ></b-form-checkbox>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb-4">
          <div class="row">
            <div class="col-md-3 col-xl-6">
              <label>{{ $t("24") }}{{ $t("hr_display_time") }}</label>
            </div>
            <div class="col-md-9 col-xl-6">
              <b-form-checkbox
                v-model="cinema_config.cine_display_24hr_time"
                value="Y"
                unchecked-value="N"
                name="check-button"
                switch
                class="j-checkbox mb-0 ml-2"
              ></b-form-checkbox>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb-4">
          <div class="row">
            <div class="col-md-3 col-xl-6">
              <label>{{ $t("directsale") }}</label>
            </div>
            <div class="col-md-9 col-xl-6">
              <div>
                <b-form-checkbox
                  v-model="cinema_config.cine_direct_sale"
                  value="Y"
                  unchecked-value="N"
                  name="check-button"
                  switch
                  class="j-checkbox mb-0 ml-2"
                ></b-form-checkbox>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb-4">
          <div class="row">
            <div class="col-md-3 col-xl-6">
              <label>{{ $t("active") }}</label>
            </div>
            <div class="col-md-9 col-xl-6">
              <div>
                <b-form-checkbox
                  v-model="cinema_config.cine_setting_is_active"
                  value="Y"
                  unchecked-value="N"
                  name="check-button"
                  switch
                  class="j-checkbox mb-0 ml-2"
                ></b-form-checkbox>
              </div>
            </div>
          </div>
        </div>

        <section class="mb-5 w-100 px-3 cms-section-new">
          <div
            class="section-title mb-3 d-flex justify-content-between section-collapse-box"
            v-b-toggle.cmsBlock
          >
            <span> {{ $t("CMS") }} </span>
            <button type="button" class="btn-transparent chevron">
              <img
                src="@/assets/img/icons/primary/chevron-down.svg"
                height="24"
                width="24"
              />
            </button>
          </div>
          <b-collapse
            id="cmsBlock"
            class="mt-2"
            v-model="sectionCollapse.cmsBlock"
          >
            <div class="bn-tabs-nav">
              <button
                v-for="(content, contentIndex) in CMS"
                :key="contentIndex"
                :class="[
                  'btn-tab-title ',
                  { active: contentIndex == activeClass },
                ]"
                @click.prevent.stop="onChangeTabHandler($event, contentIndex)"
              >
                <strong>
                  <span :class="notempty[contentIndex] ? '' : 'text-danger'">{{
                    content.langauge
                  }}</span>
                </strong>
              </button>
            </div>
            <div class="bn-tabs-content">
              <div v-for="(content, contentIndex) in CMS" :key="contentIndex">
                <div v-if="contentIndex === activeClass">
                  <div class="row mx-0 rounded mb-4">
                    <div class="col-12 mt-3">
                      <div class="row">
                        <div class="col-lg-6 col-xl-6 mb-3">
                          <div
                            class="d-flex justify-content-evenly align-item-center"
                          >
                            <label
                              class="material-file-upload cms_header_image"
                              @click.prevent.stop="
                                setCMSImageData('CMS_header', contentIndex)
                              "
                            >
                              <div
                                class="label"
                                v-bind:class="{
                                  'shift-up': content.cmsHeader.image_url,
                                }"
                              >
                                {{ "Cinema Header Image" }}
                              </div>
                              <div class="uploaded-file-name">
                                <div class="text-truncate pt-2">
                                  {{ content.cmsHeader.image_url }}
                                </div>
                              </div>
                            </label>

                            <!-- <Tooltip
                              class="mt-2"
                              :title="`cinema header image`"
                            /> -->
                            <img
                              width="40"
                              height="40"
                              class="rounded c-pointer ml-2"
                              @click="
                                openImageModal(
                                  'CMS_header',
                                  contentIndex,
                                  index
                                )
                              "
                              :src="_GetImagePath(content.cmsHeader.image_url)"
                              v-if="content.cmsHeader.image_url"
                            />
                            <img
                              v-else
                              width="35"
                              height="35"
                              class="rounded ml-2"
                              alt="Empty Image"
                              src="@/assets/img/icons/empty-image.svg"
                            />
                          </div>
                        </div>
                        <div class="col-lg-6 col-xl-6 mb-3">
                          <div class="d-flex align-items-center">
                            <div class="dropdown-curve-container">
                              <label
                                :class="
                                  content.cmsHeader.sound_formats
                                    ? 'shift-up'
                                    : ''
                                "
                              >
                                Available {{ $tc("Sound", 1) }}
                                {{ $tc("Format", 1) }}
                              </label>
                              <multiselect
                                v-model="content.cmsHeader.sound_formats"
                                :multiple="true"
                                :options="soundFormatList"
                                :searchable="true"
                                label="sound_format_name"
                                track-by="sound_format_id"
                                placeholder=""
                                select-label="Select"
                                deselect-label="Remove"
                              ></multiselect>
                            </div>
                            <!-- <Tooltip :title="$t('available_sound_formats')" /> -->
                          </div>
                          <p class="error_message"></p>
                        </div>
                        <div class="col-lg-12 col-xl-12 align-self-center mb-3">
                          <div class="d-flex align-items-center">
                            <div class="input-material-textarea">
                              <textarea
                                v-model="content.cmsHeader.description"
                                rows="4"
                                placeholder="."
                                name="description"
                              ></textarea>
                              <label>Cinema Sub-Header</label>
                            </div>
                            <!-- <Tooltip :title="$t('cms_desc')" /> -->
                          </div>
                        </div>
                        <div class="col-md-6 mb-4">
                          <div class="row">
                            <div class="col-md-4">
                              <label>Show Cinema Address</label>
                            </div>
                            <div class="col-md-3">
                              <div>
                                <b-form-checkbox
                                  v-model="
                                    content.cmsHeader.show_cinema_address
                                  "
                                  value="Y"
                                  unchecked-value="N"
                                  name="check-button"
                                  switch
                                  class="j-checkbox mb-0 mr-3"
                                ></b-form-checkbox>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="content.cmsData.length > 0">
                    <div
                      class="row border mx-0 rounded mb-4"
                      v-for="(item, index) in content.cmsData"
                      :key="index"
                    >
                      <div class="col-11 pt-4">
                        <div class="col-12">
                          <div class="row">
                            <div
                              class="col-lg-6 col-xl-6 align-self-center mb-3"
                            >
                              <div class="d-flex align-items-center">
                                <div class="input-material">
                                  <input
                                    placeholder="Title"
                                    type="text"
                                    name="title"
                                    v-model="item.title"
                                  />
                                  <label>{{ $t("cms_title") }}</label>
                                </div>
                                <!-- <Tooltip :title="$t('cms_title')" /> -->
                              </div>
                            </div>
                            <div
                              class="col-lg-12 col-xl-12 align-self-center mb-3"
                            >
                              <div class="d-flex align-items-center">
                                <div class="input-material-textarea">
                                  <textarea
                                    v-model="item.description"
                                    rows="4"
                                    placeholder="."
                                    name="description"
                                  ></textarea>
                                  <label>{{ $t("cms_desc") }}</label>
                                </div>
                                <!-- <Tooltip :title="$t('cms_desc')" /> -->
                              </div>
                            </div>
                            <div
                              class="col-lg-6 col-xl-6 align-self-center mb-3"
                            >
                              <div class="d-flex align-items-center">
                                <div class="input-material">
                                  <input
                                    placeholder="Description"
                                    type="text"
                                    name="desc"
                                    v-model="item.button_text"
                                  />
                                  <label>{{ $t("cms_btn_text") }}</label>
                                </div>
                                <!-- <Tooltip :title="$t('cms_btn_tooltip')" /> -->
                              </div>
                            </div>
                            <div
                              class="col-lg-6 col-xl-6 align-self-center mb-3"
                            >
                              <div class="d-flex align-items-center">
                                <div class="input-material">
                                  <input
                                    placeholder="Button Url"
                                    type="text"
                                    name="url"
                                    v-model="item.button_url"
                                  />
                                  <label>{{ $t("cms_btn_url") }}</label>
                                </div>
                                <!-- <Tooltip :title="$t('cms_btn_url_tooltip')" /> -->
                              </div>
                            </div>
                            <div class="col-lg-6 col-xl-6 mb-3">
                              <div
                                class="d-flex justify-content-between align-item-center"
                              >
                                <label
                                  class="material-file-upload"
                                  @click.prevent.stop="
                                    setCMSImageData('CMS', contentIndex, index)
                                  "
                                >
                                  <div
                                    class="label"
                                    v-bind:class="{
                                      'shift-up': item.image_url,
                                    }"
                                  >
                                    {{ "CMS Image" }}
                                  </div>
                                  <div class="uploaded-file-name">
                                    <div
                                      class="text-truncate pt-2 image_url_text"
                                    >
                                      {{ item.image_url }}
                                    </div>
                                  </div>
                                </label>

                                <!-- <Tooltip class="mt-2" :title="`CMS Image`" /> -->
                                <img
                                  width="40"
                                  height="40"
                                  class="rounded c-pointer ml-2"
                                  @click="
                                    openImageModal('CMS', contentIndex, index)
                                  "
                                  :src="_GetImagePath(item.image_url)"
                                  v-if="item.image_url"
                                />
                                <img
                                  v-else
                                  width="35"
                                  height="35"
                                  class="rounded ml-2"
                                  alt="Empty Image"
                                  src="@/assets/img/icons/empty-image.svg"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        class="col-1 d-flex align-items-center justify-content-center border-left"
                      >
                        <button
                          v-if="index === 0 && false"
                          @click.prevent.stop="
                            addCMSBlock($event, contentIndex)
                          "
                          class="btn-transparent"
                        >
                          <img
                            src="@/assets/img/icons/plus.svg"
                            height="35"
                            width="35"
                          />
                        </button>
                        <button
                          @click.prevent.stop="
                            removeCMSBlock($event, contentIndex, index)
                          "
                          class="btn-transparent"
                        >
                          <img
                            src="@/assets/img/icons/minus.svg"
                            height="35"
                            width="35"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <div class="row w-100 pl-5">
                      <p class="mx-auto text-muted">Add Block</p>
                    </div>
                  </div>
                  <div
                    class="col-12 d-flex align-items-center justify-content-center border-top mt-5 mb-5 position-relative"
                  >
                    <button
                      @click.prevent.stop="addCMSBlock($event, contentIndex)"
                      class="btn-transparent add-more-button"
                    >
                      <img
                        src="@/assets/img/icons/plus.svg"
                        height="35"
                        width="35"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </b-collapse>
        </section>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="onFinalSubmit(true)"
            class="btn-blue"
          >
            {{ $t("save") }}
          </button>
          <button
            :disabled="btenable"
            @click.prevent.stop="onFinalSubmit(false)"
            class="btn-blue"
          >
            {{ $t("saveaddmore") }}
          </button>
          <button @click.prevent.stop="onResetForm" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="/cinema-manager/cinemas"
            >{{ $t("cancel") }}</b-button
          >
        </div>
        <b-modal
          ref="preview-modal"
          id="selected-image-preview-modal"
          size="lg"
          hide-header
          hide-footer
        >
          <label class="h4 mt-2 mb-4 text-center">{{ PreviewHeading }}</label>
          <button
            class="btn-modal-close"
            @click="$bvModal.hide('selected-image-preview-modal')"
          >
            &times;
          </button>
          <br />
          <img
            v-if="previewType == 2"
            :src="
              _GetImagePath(
                CMS[previewLanguage].cmsData[previewIndex].image_url
              )
            "
            class="img-fluid"
          />
          <img
            v-else-if="previewType == 1"
            :src="_GetImagePath(cinema_config.temp_artwork_image_path)"
            class="img-fluid"
          />
          <img
            v-else-if="previewType == 3"
            :src="_GetImagePath(CMS[previewLanguage].cmsHeader.image_url)"
            class="img-fluid"
          />
          <div v-else class="mx-auto w-100">
            {{ "No Preview Available" }}
          </div>
        </b-modal>
      </div>
    </div>
    <ImageGallery
      v-bind:propImageName="calledBy == 1 ? 'ArtWork Image' : 'Image'"
      v-bind:openModal="showModal"
      v-bind:set_height="calledBy == 1 ? set_height : NaN"
      v-bind:set_width="calledBy == 1 ? set_width : NaN"
      :showPercentageLoader="true"
      :img_desc="calledBy == 1 ? 'Temporary Movie Artwork Image' : 'CMS Image'"
      :resetImgData="false"
      :language="
        calledBy == 2 ? this.ContentLanguages[this.imageLangIndex] : {}
      "
      :category="'Movie Poster'"
    ></ImageGallery>
  </div>
</template>

<script>
import CinemasService from "@/services/CinemasService";
import MasterService from "@/services/MasterService";
import MovieService from "@/services/MovieService";
import SetupService from "@/services/SetupService";
import scheduleService from "@/services/scheduleService";
import moment from "moment-timezone";
import DatePicker from "vue2-datepicker";
import Multiselect from "vue-multiselect";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import ImageGallery from "../../ImageGallery/imageGalleryModal";
import { mapGetters } from "vuex";

export default {
  components: {
    DatePicker,
    Multiselect,
    VueTimepicker,
    ImageGallery,
    VueCropper,
  },
  data() {
    return {
      btenable: false,
      timeZones: [],
      isCinemaID: true,
      submitted: false,
      selected: null,
      selectedCinema: "",
      selectedTimeZone: "",
      selected_time_zone: "",
      selectedlanguage: "",
      Cinemas: [],
      value: [],
      language: [],
      cinema_config: {
        cine_id: null,
        discount_is_available_on: "GrossAmount",
        cine_concession_level: null,
        cine_application_language_id: null,
        cine_operation_start_time: "",
        cine_operation_end_time: "",
        cine_cleaning_time_in_mins: "",
        cine_setting_ads_time_in_mins: "",
        cine_interval_time_in_mins: "",
        cine_seat_release_time_in_mins: "",
        cine_cutoff_time_in_mins: "",
        kiosk_cutoff_time_in_mins: "",
        website_cutoff_time_in_mins: "",
        entry_after_show_start: "",
        entry_before_show_start: "",
        cine_display_24hr_time: "Y",
        cine_online_visibility: "Y",
        cine_include_float_amount: "Y",
        cine_include_shift_close: "Y",
        cine_sell_fnb_in_boxoffice: "Y",
        cine_direct_sale: "Y",
        cine_ipaddress_range: "",
        cine_setting_is_active: "Y",
        cine_time_zone: "",
        start_time: "",
        end_time: "",
        mycinema_creation_interval: "",
        start_day: "",
        temp_artwork_image_path: "",
      },
      set_width: 2160,
      set_height: 3050,
      showModal: false,
      selectedScreens: [],
      screens: [],
      Days: [
        { id: 1, day: "Monday" },
        { id: 2, day: "Tuesday" },
        { id: 3, day: "Wednesday" },
        { id: 4, day: "Thursday" },
        { id: 5, day: "Friday" },
        { id: 6, day: "Saturday" },
        { id: 7, day: "Sunday" },
      ],
      selected_day: "",
      sectionCollapse: {
        cmsBlock: true,
      },
      CMS: [],
      ContentLanguages: [],
      CMSContent: [],
      activeClass: 0,
      notempty: [false, false, false, false, false, false],
      imageLangIndex: null,
      imageCMSIndex: null,
      calledBy: 0,
      PreviewHeading: "Image Preview",
      previewType: 0,
      previewLanguage: null,
      previewIndex: null,
      cinemaID: null,
      soundFormatList: [],
      ShowTypeArray: [
        {
          booking_type_id: "4",
          screening_name: "Classic Programming",
          column_name: "is_classic_show",
          status: true,
        },
        {
          booking_type_id: "1",
          screening_name: "Confirmed",
          column_name: "is_confirmed_show",
          status: true,
        },
        {
          booking_type_id: "2",
          screening_name: "Crowd Source",
          column_name: "is_crowd_show",
          status: true,
        },
        {
          booking_type_id: "3",
          screening_name: "Private",
          column_name: "is_private_show",
          status: true,
        },
        {
          booking_type_id: "5",
          screening_name: "Movie Club",
          column_name: "is_movie_club",
          status: true,
        },
      ],
    };
  },
  mounted() {
    const { cinema_id } = this.$route.query;
    if (cinema_id) {
      this.cinemaID = cinema_id;
      this.getCinemaList(cinema_id);
      this.getAllActiveScreens(cinema_id);
    } else {
      this.getCinemaList();
      this.isCinemaID = false;
    }
    // this.getCinemaList();
    this.getlanguagelist();
    // this.getTimeZonesList();
    this.getTimeZonesList();
    this.getSoundFormats();
  },
  beforeMount() {
    this.getContentLangauge();
  },
  computed: {
    ...mapGetters(["finalImagePath"]),
  },
  watch: {
    finalImagePath(newval) {
      if (this.calledBy == 2) {
        this.CMS[this.imageLangIndex].cmsData[this.imageCMSIndex].image_url =
          newval;
        this.$forceUpdate();
      } else if (this.calledBy == 1) {
        this.cinema_config.temp_artwork_image_path = newval;
      } else if (this.calledBy == 3) {
        this.CMS[this.imageLangIndex].cmsHeader.image_url = newval;
        this.$forceUpdate();
      }
    },
  },
  methods: {
    getScreenType(columnName) {
      let ShowType = "";
      ShowType = this.ShowTypeArray.find((x) => x.column_name == columnName);
      return ShowType && ShowType.status ? "Y" : "N";
    },
    createShowTypeArray(obj) {
      Object.keys(obj).forEach((x) => {
        this.ShowTypeArray.forEach((y) => {
          if (y["column_name"] == x) {
            y["status"] = obj[x] == "Y";
          }
        });
      });
    },
    onSelectSoundFormatHandler(format, index) {
      console.log("format", format);
      this.CMS[index].cmsHeader.sound_formats.push(format.sound_format_name);
    },
    onRemoveSoundFormat(format, index) {
      let formatIndex = this.CMS[index].cmsHeader.sound_formats.findIndex(
        (x) => {
          return x.sound_format_name == format.sound_format_name;
        }
      );
      this.CMS[index].cmsHeader.sound_formats.splice(formatIndex, 1);
    },
    onChangeTabHandler: function (event, index) {
      this.activeClass = index;
    },
    addCMSBlock(event, langIndex) {
      let block = {
        title: "",
        description: "",
        image_url: "",
        button_text: "",
        button_url: "",
      };
      this.CMS[langIndex].cmsData.push(block);
    },
    removeCMSBlock(event, LangIndex, index) {
      this.CMS[LangIndex].cmsData.splice(index, 1);
      if (this.CMS[LangIndex].cmsData.length == 0) {
        this.notempty[LangIndex] = false;
      }
      this.$forceUpdate();
    },
    getSoundFormats: function () {
      let payload = {
        tableName: "ms_sound_formats",
        sound_format_is_active: "Y",
        orderBy: "asc",
        columnName: "sf_order",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.soundFormatList = data.Records;
          } else {
            console.log("show error :", data.message);
          }
        })
        .catch((error) => {
          console.log("show error :", error);
        });
    },
    getContentLangauge: function () {
      MovieService.GetMovieContentLanguages()
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            if (data.ContentLanguages.length > 0) {
              // this.ContentLanguages = _.sortBy(data.ContentLanguages, [
              //   "langauge"
              // ]);
              this.ContentLanguages = data.ContentLanguages;
            }
            console.log("this.ContentLanguages", this.ContentLanguages);
          } else {
            // Show Error:
            console.log("data.message :", data.message);
          }
          return;
        })
        .then(() => {
          this.makeLangContainers();
        })
        .catch((error) => {
          // Catch Error:
          console.log("Catch Error On getMovieContentLangauge :", error);
        });
    },
    makeLangContainers: function () {
      this.ContentLanguages.map((x) => {
        let Obj = {
          ...x,
          cinema_id: this.cinemaID,
          selectedFormats: [],
          cmsHeader: {
            sound_formats: [],
            image_url: "",
            description: "",
            show_cinema_address: "Y",
          },
          cmsData: [],
        };
        this.CMS.push(Obj);
        console.log("this.CMS", this.CMS);
      });
    },
    CheckEmptyContent: function (content, index, langIndex) {
      if (content.title && content.description) {
        this.notempty[langIndex] = true;
      } else {
        this.notempty[langIndex] = false;
      }
    },
    setModalData() {
      this.calledBy = 1;
      this.showModal = !this.showModal;
    },
    setCMSImageData(type, langIndex, cmsIndex) {
      if (type == "CMS") {
        this.calledBy = 2;
        this.imageLangIndex = langIndex;
        this.imageCMSIndex = cmsIndex;
        this.showModal = !this.showModal;
      } else if (type == "CMS_header") {
        this.calledBy = 3;
        this.imageLangIndex = langIndex;
        this.showModal = !this.showModal;
      }
    },
    openImageModal: function (type, langIndex, index) {
      if (type == "CMS") {
        this.previewType = 2;
        this.previewLanguage = langIndex;
        this.previewIndex = index;
        this.PreviewHeading = "Image Preview";
      } else if (type == "CMS_header") {
        this.previewType = 3;
        this.previewLanguage = langIndex;
        this.PreviewHeading = "Image Preview";
      } else {
        this.previewType = 1;
        this.PreviewHeading = "Temporary Movie Artwork Image";
      }
      this.$refs["preview-modal"].show();
    },
    onChangeTime(event, type) {
      event = new Date(
        moment(event.displayTime, "HH:mm").format("YYYY-MM-DD, HH:mm:ss")
      );
      if (type == "start") {
        this.cinema_config.cine_operation_start_time = event;
      } else if (type == "end") {
        this.cinema_config.cine_operation_end_time = event;
      }
    },
    onClickScreen(event, screen, index) {
      console.log("screens log", screen);
      let isExists = this.selectedScreens.find((x) => {
        return x.screen_id == screen.screen_id;
      });
      if (isExists) {
        this.selectedScreens.splice(
          this.selectedScreens.findIndex(function (i) {
            return i.screen_id === screen.screen_id;
          }),
          1
        );
      } else {
        this.selectedScreens.push(screen);
      }
      console.log("selectedScreens", this.selectedScreens);

      if (event && event.target) {
        event.target.blur();
      }
    },
    getAllActiveScreens: function (cinema_id) {
      console.log("cinema_id :", cinema_id);
      this.ScreenList = [];
      let payload = {
        cinema_id: cinema_id,
      };

      scheduleService
        .GetScreens(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.screens = data.Records.filter((x) => {
              return (
                x.screen_seat_types.length > 0 &&
                x.totalSeatLayout > 0 &&
                x.screen_seat_card_mapping.length >= x.screen_seat_types.length
              );
            });
          } else {
            // Show Message Here:
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          // Catch Error:
          this.$toasted.show(Error(error));
          console.log("Catch Error on getAllActiveScreens :", error);
        });
    },
    getlanguagelist: function () {
      this.language = [];
      let payload = {
        tableName: "ms_language",
        lang_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.language = data.Records;
          } else {
            console.log("show error1 :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    onclose: function (e) {},

    getCinemaList: function (cine_id) {
      this.Cinemas = [];
      let body = {
        activekey: "cine_is_active",
      };
      CinemasService.GetActiveCinemas(body)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.Cinemas.map((x) => {
              if (String(cine_id) === String(x.cine_id)) {
                this.selectedCinema = x.cine_name;
                this.cinema_config.cine_id = x.cine_id;
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    getTimeZonesList: function () {
      CinemasService.getTimeZoneList()
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.timeZones = data.Records;
          } else {
            // Show Error Message:
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectTimeZone: function (event, params) {
      this.selectedTimeZone = params;
      // this.cinema_config.cine_time_zone = params.cine_time_zone;
    },
    onSelectDay(Day) {
      this.selected_day = Day;
      this.cinema_config.start_day = Day.day;
    },
    onSelectCinema: function (event, params) {
      this.selectedCinema = params.cine_name;
      this.cinema_config.cine_id = params.cine_id;
      this.cinemaID = params.cine_id;
      this.getAllActiveScreens(params.cine_id);
      // console.log("object :", params);
    },
    onSelectLanguage: function (event, params) {
      this.selectedlanguage = params.lang_name;
      this.cinema_config.cine_application_language_id = params.lang_id;
    },
    onResetForm: function () {
      this.selectedCinema = "";
      this.selectedTimeZone = "";
      this.selectedlanguage = "";
      (this.selectedScreens = []),
        (this.cinema_config = {
          cine_id: null,
          discount_is_available_on: "GrossAmount",
          cine_concession_level: "",
          cine_application_language_id: "",
          cine_operation_start_time: "",
          cine_operation_end_time: "",
          cine_cleaning_time_in_mins: "",
          cine_setting_ads_time_in_mins: "",
          cine_interval_time_in_mins: "",
          cine_seat_release_time_in_mins: "",
          cine_cutoff_time_in_mins: "",
          kiosk_cutoff_time_in_mins: "",
          website_cutoff_time_in_mins: "",
          cine_display_24hr_time: "Y",
          cine_online_visibility: "Y",
          cine_include_float_amount: "Y",
          cine_sell_fnb_in_boxoffice: "Y",
          cine_direct_sale: "Y",
          cine_ipaddress_range: "",
          cine_setting_is_active: "Y",
          cine_time_zone: "",
        });
    },

    onFinalSubmit: function (flag) {
      this.submitted = true;
      console.log("screens", this.selectedScreens);
      function format24Hours(date) {
        let newVal = date;
        let finalVal = moment(newVal).format("H:mm");
        return finalVal;
      }

      this.$validator.validate().then((valid) => {
        if (valid) {
          // console.log(
          //   "selected_time_zone :",
          //   this.cinema_config.cine_time_zone.tz_id
          // );

          if (
            this.cinema_config.cine_time_zone &&
            this.cinema_config.cine_time_zone.tz_id
          ) {
            this.cinema_config.cine_time_zone =
              this.cinema_config.cine_time_zone.tz_id;

            let payload = {
              ...this.cinema_config,
              cine_operation_start_time: moment(
                this.cinema_config.cine_operation_start_time
              ).format("HH:mm"),
              cine_operation_end_time: moment(
                this.cinema_config.cine_operation_end_time
              ).format("HH:mm"),
              mycinema_creation_interval:
                parseInt(this.cinema_config.mycinema_creation_interval) || null,
              cine_offer_applicable_on_gross: "N",
              cine_offer_applicable_on_net: "N",
              screens: this.selectedScreens,
              CMS: this.CMS,
            };

            if (
              this.cinema_config["discount_is_available_on"] &&
              this.cinema_config["discount_is_available_on"] === "GrossAmount"
            ) {
              payload["cine_offer_applicable_on_gross"] = "Y";
            } else if (
              this.cinema_config["discount_is_available_on"] &&
              this.cinema_config["discount_is_available_on"] === "NetAmount"
            ) {
              payload["cine_offer_applicable_on_net"] = "Y";
            }
            delete payload.discount_is_available_on;
            console.log("payload :", payload);

            this.btenable = true;

            payload.is_confirmed_show = this.getScreenType("is_confirmed_show");
            payload.is_private_show = this.getScreenType("is_private_show");
            payload.is_crowd_show = this.getScreenType("is_crowd_show");
            payload.is_movie_club = this.getScreenType("is_movie_club");
            payload.is_classic_show = this.getScreenType("is_classic_show");

            scheduleService
              .AddCinemaSettings(payload)
              .then((response) => {
                this.btenable = false;
                const { data } = response;
                if (data && data.status) {
                  this.onResetForm();
                  this.$toasted.show("Cinema Setting Created Successfully");
                  if (flag) {
                    this.$router.push({
                      path: "/cinema-manager/cinemas",
                    });
                  } else {
                    this.submitted = false;
                  }
                } else {
                  this.$toasted.show(data.message);
                }
              })
              .catch(this._CatchError)
              .finally(() => {
                this.btenable = false;
              }); //message
          } else {
            this.$toasted.show("Please Select Time Zone");
          }
        }
      });
    },
  },
};
</script>

<style>
.img-preview:hover {
  left: -137px !important;
}

.image_url_text {
  width: 170px;
}

.section-collapse-box {
  border: 1px solid var(--lightgrey);
  border-radius: 10px;
  padding: 10px;
}

.cms-section-new .section-title {
  font-size: 22px;
}

.cms_header_image {
  max-width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/CinemaSettingsComponents/addCinemaSettings.vue